<template>
  <div v-if="isAdmin">
    <v-radio-group v-model="form.userPresentation"
                   :label="ownerLabel"
                   mandatory
                   @change="changeOwner">
      <v-radio label="One or more groups"
               :value="0">
      </v-radio>
      <v-radio label="Only me"
               :value="1">
      </v-radio>
      <v-radio label="Someone else"
               :value="2">
      </v-radio>
    </v-radio-group>

    <v-autocomplete v-model="form.owner_id"
                    v-if="form.userPresentation === 2"
                    label="Who?"
                    placeholder=" "
                    :items="filteredUsers"
                    item-value="id"
                    item-text="name">
    </v-autocomplete>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import clone from 'lodash/clone';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    ownerLabel: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'team',
      'user',
      'users',
    ]),
    filteredUsers() {
      const users = clone(this.users);
      users.unshift({id: '', name: 'Select user'});
      return users;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    changeOwner() {
      switch (this.form.userPresentation) {
        case 0:
          this.form.owner_id = '';
          break;
        case 1:
          this.form.owner_id = this.user.id;
          break;
        case 2:
          this.form.owner_id = '';
          break;
      }
    },
    fetchData() {
      this.$store.dispatch('fetchUsers');
    },
  }
}
</script>
